module.exports = __webpack_public_path__ + "img/disappointed_shipper.091f610.svg";